import React from "react";
import styled from "styled-components";

function BioDiv() {
  return (
    <Wrapper>
      <BioSpan>
        <b>Rob Feulner Quiñones</b> (b. 1987) is a video artist hailing from Montréal, Québec.
        Armed with a stack of VCRs, circuit-bent equipment, and a disregard for
        electrical shocks, Rob Feulner dives wrist-deep into open machinery to
        manipulate tape heads and moving parts, creating a landscape of video
        tracking errors and glitches used to confront modern political malaise.
        His work has appeared in the Indianapolis Museum of Art, has been
        broadcasted on Adult Swim, featured in Matthew Rankin's <i>Ladies and Gentlemen, Brian Mulroney</i>,
         and provided visuals for a performance of Anne Carson's <i>Antigone</i>, in collaboration with the Nobel Prize-winning author. Established in 2014, Feulner's video art label Bleu Nuit Video
        curates underrepresented like-minded artists through DVD and VHS home
        releases.
      </BioSpan>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: min(100%, 70ch);
  gap: 2vh;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 10%;
  }
`;

const BioSpan = styled.span`
  font-size: 1.25em;
  line-height: 1.55;

  @media screen and (max-width: 768px) {
    font-size: 1.05em;
  }
`;

export default BioDiv;
